'use client';

import clsx from 'clsx';

import { useAppConfigStore } from '@northladder/services';

import { BrandHeader } from './BrandHeader';
import { IMenuItemBaseOptions, SidebarMenuItem } from './SidebarMenuItem';
import { SidebarToggleButton } from './SidebarToggleButton';

interface ISidebarProps {
  className?: string;
  items: IMenuItemBaseOptions[];
}

/**
 * -----------------------------------------------------------------------------
 * It renders a sidebar with brand header and menu items for multiple views.
 */
export function Sidebar({ className, items }: ISidebarProps) {
  const { isSidebarExpanded } = useAppConfigStore();

  return (
    <div
      className={clsx(
        `
          hidden bg-white transition-all duration-500 ease-in-out lg:fixed
          lg:inset-y-0 lg:z-50 lg:flex lg:flex-col
        `,
        isSidebarExpanded ? 'lg:w-60' : 'w-20',
        className
      )}
    >
      <SidebarToggleButton />

      <div
        className={clsx(
          'pb-6 pt-4 transition-all duration-500 ease-in-out',
          isSidebarExpanded ? 'px-4' : 'px-1'
        )}
      >
        <BrandHeader />

        <div className="flex flex-col gap-2 pt-12">
          {items.map((item) => (
            <SidebarMenuItem
              key={item.href}
              isExpanded={isSidebarExpanded}
              item={item}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
